/**
 * Centralized project constants to prevent drift in marketing copy
 * Update these values in ONE place - they propagate across the entire site
 */

// Inventory labels - SINGLE SOURCE OF TRUTH for apartment configurations
export const INVENTORY_LABEL = '3 & 4 BHK';
export const INVENTORY_LABEL_LONG = '3 and 4 BHK';
export const INVENTORY_LABEL_FULL = '2, 3 & 4 BHK'; // When including all configurations
export const INVENTORY_CONFIGS = ['2 BHK', '3 BHK', '4 BHK'] as const;

// SEO-optimized taglines using inventory constants
export const SEO_TAGLINES = {
  short: `Uber-luxury ${INVENTORY_LABEL} residences in Chandivali, Mumbai`,
  medium: `Uber-luxury ${INVENTORY_LABEL} residences starting 1,069+ sq.ft.`,
  long: `Premium ${INVENTORY_LABEL} residences in Chandivali near Powai, surrounded by a Miyawaki forest`,
} as const;
